import { valorEhNulo } from '@/util'

const mapearObjetoCombo = ({ campo, codigo, label }) => {
  if (valorEhNulo(campo)) return null
  const id = obterCodigoCombo({ campo, codigo })
  const name = !valorEhNulo(campo[label]) ? campo[label] : null

  return {
    code: id,
    label: name
  }
}

const obterCodigoCombo = ({ campo, codigo = 'code' }) => {
  if (valorEhNulo(campo)) return null

  const id = !valorEhNulo(campo[codigo]) ? campo[codigo] : null
  return id
}

export default {
  mapearObjetoCombo,
  obterCodigoCombo
}
